import { Box, type BoxProps } from "@mui/material";

type ResponsiveSplitContainerProps = BoxProps & {
  gap?: string | number;
};

const ResponsiveSplitContainer: React.FC<ResponsiveSplitContainerProps> = ({
  children,
  gap = "1.5em",
  ...rest
}) => {
  return (
    <Box
      gap={gap}
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        "@media (min-width: 1440px)": {
          display: "grid",
          alignItems: "flex-start",
          justifyContent: "space-between",
          gridTemplateColumns: "minmax(0, 600px) minmax(600px, 600px)",
        },
      }}
      {...rest}
    >
      {children}
    </Box>
  );
};

export default ResponsiveSplitContainer;
